export class SelfIncreaseCount {
    static _count = 0;
    static get count() {
        return SelfIncreaseCount._count++;
    }
    static get root() {
        return 0;
    }
}
